import createHeaders from "@utils/createHeaders";

const baseQrisHeaders = [
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Bill Number', value: 'bill_num' },
  { text: 'Merchant Name', value: 'merchant_name'},
  { text: 'MID', value: 'mid'},
  { text: 'Merchant PAN', value: 'mpan'},
  { text: 'Reff ID', value: 'rrn'},
  { text: 'QR Method', value: 'qr_method'},
  { text: 'QR Type', value: 'qr_type'},
  { text: 'Transaction Type', value: 'trx_type'},
  { text: 'Issuer Name', value: 'issuer_name' },
  { text: 'Customer PAN', value: 'customer_pan'},
  { text: 'Customer Name', value: 'customer_name'},
  { text: 'Payment Type', value: 'payment_type'},
  { text: 'Acquirer Name', value: 'payment_channel'},
  { text: 'Amount', value: 'amount'},
  { text: 'MDR', value: 'amount_mdr'},
  { text: 'Net Amount', value: 'amount_net'},
  { text: 'Transaction Date', value: 'trx_datetime'},
  { text: 'Status', value: 'status'},
  { text: 'Settlement Status', value: 'settlement_status'},
  { text: 'Settlement Date', value: 'settlement_datetime'},
  { text: 'Source of Fund', value: 'payment_method'},
  { text: 'Additional Data', value: 'additional_data'},
  { text: 'Promo Code', value: 'promo_code'},
  { text: 'Switcher Name', value: 'switcher_name'},
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
];

const cptsExcludeFields = new Set(['customer_name', 'additional_data', 'promo_code', 'settlement_datetime']);
const cptsFirstField = { text: 'Invoice Number', value: 'invoice_number' };

export const getHeaders = (tabType) => {
  if (tabType === 'cpts') {
    const headers = baseQrisHeaders
      .filter(h => !cptsExcludeFields.has(h.value))
      .map((h) => {
        if (h.value === 'bill_num') {
          return cptsFirstField;
        }
        return h;
      });
    return createHeaders(headers);
  }
  return createHeaders(baseQrisHeaders);
};

export const headers = getHeaders('qris');

export const getSearch = (tabType) => {
  const baseSearch = {
    trx_datetime: [],
    payment_type: '',
    rrn: '',
    mid: '',
    status: '',
  };
  
  if (tabType === 'cpts') {
    return {
      ...baseSearch,
      invoice_number: '',
    };
  }
  
  return {
    ...baseSearch,
    bill_num: '',
    promo_code: '',
    qr_method: ''
  };
};

export const search = getSearch('qris');

const baseQrisEditedItem = {
  number_index: '',
  bill_num: '',
  merchant_name: '',
  mid: '',
  mpan: '',
  rrn: '',
  qr_method: '',
  qr_type: '',
  trx_type: '',
  issuer_name: '',
  customer_pan: '',
  customer_name: '',
  payment_type: '',
  payment_channel: '',
  amount: '',
  amount_mdr: '',
  amount_net: '',
  trx_datetime: '',
  status: '',
  settlement_status: '',
  payment_method: '',
  additional_data: '',
  promo_code: '',
  switcher_name: '',
  product_indicator: '',
};

export const getEditedItem = (tabType) => {
  if (tabType === 'cpts') {
    const { bill_num, customer_name, additional_data, promo_code, ...cpts } = baseQrisEditedItem;
    return {
      ...cpts,
      invoice_number: '',
    };
  }
  return baseQrisEditedItem;
};

export const editedItem = getEditedItem('qris');
